<template>
  <div class="login-container">
    <el-card class="login-card" shadow="hover">
      <h2 class="login-title">Авторизация</h2>
      <el-form @submit.prevent="handleLogin">
        <el-form-item>
          <el-input
            v-model="username"
            placeholder="Username"
            prefix-icon="el-icon-user"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="password"
            type="password"
            placeholder="Password"
            prefix-icon="el-icon-lock"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" block>Войти</el-button>
        </el-form-item>
      </el-form>
      <p v-if="message" class="error-message">{{ message }}</p>
    </el-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import authService from "../services/authService";
import {AccessTokenDecoded, AuthRequest} from "@/types/auth";

export default defineComponent({
  name: "LoginView",
  setup() {
    const username = ref("");
    const password = ref("");
    const message = ref("");
    const router = useRouter();

    const handleLogin = async () => {
      if (window.location.hostname == 'cost.fincenter.kz' ) {
        alert('Внимание! Сайт временно недоступен. Пожалуйста, используйте чуть позже');
        return;
      }

      const requestData: AuthRequest = {
        username: username.value,
        password: password.value,
      };
      try {
        const response = await authService.login(requestData);
        if (response.access_token) {
          let username = response.username;

          const decoded: AccessTokenDecoded = authService.decode(response.access_token || "");
          if (decoded && decoded.name) {
            username = decoded.name || response.username;
          }

          ElMessage.success(`Добро пожаловать, ${username}!`);
          await router.push("/");
        } else {
          message.value = "Invalid login credentials.";
        }
      } catch (error) {
        message.value = "Login failed. Please try again.";
        ElMessage.error(message.value);
      }
    };

    return {
      username,
      password,
      message,
      handleLogin,
    };
  },
});
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f7fa;
}

.login-card {
  width: 400px;
  padding: 30px;
}

.login-title {
  text-align: center;
  margin-bottom: 20px;
}

.error-message {
  color: red;
  margin-top: 15px;
  text-align: center;
}
</style>
